import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "../CategoryPerformanceView/CategoryPerformanceView.module.scss";
import tableStyles from "../../../LegAnalysis/structure/QMix/QMixTile.module.scss";
import isEmpty from "lodash/isEmpty";
import StackedGroupedBarChart from "../../../../../common/GroupedStackedBarChart/GroupedStackedBarChart";
import { useAppSelector } from "../../../../../../redux/hooks";
import ViewModeSwitcher, {
  ViewMode,
} from "../../../../../common/ViewModeSwitcher/ViewModeSwitcher";
import GenericTable from "../../../../../common/GenericTable/GenericTable";
import {
  yearlyTabs,
  THEME_STYLE,
  CATEGORY_COLORS,
  ALL_PILL_COLOR,
} from "../CategoryPerformanceView/constants";
import {
  yearlyApiResponse,
  yearlyTableDataMock,
} from "../CategoryPerformanceView/mockData";

const YearlyView = () => {
  const { t } = useTranslation();
  const currentTheme: any = useAppSelector(
    (state: any) => state.theme.currentTheme
  );

  const [viewMode, setViewMode] = useState<ViewMode>("left");
  const [selectedCategory, setSelectedCategory] = useState("Beauty");

  const handleCategorySelection = (label: string) => {
    setSelectedCategory(label);
  };

  // Filter table data based on selected category
  const filteredTableData = useMemo(() => {
    if (!yearlyTableDataMock || viewMode === "left") return yearlyTableDataMock;

    const filteredRows = yearlyTableDataMock.body?.rows?.filter((row: any) => {
      const categoryName = row[0]?.kpiValue;
      return categoryName === selectedCategory;
    });

    return {
      ...yearlyTableDataMock,
      body: {
        ...yearlyTableDataMock.body,
        rows: filteredRows || [],
      },
    };
  }, [selectedCategory, viewMode]);

  return (
    <div className={styles.PY25Revenue_wrapper}>
      <div className={styles.revenue_title_wrapper}>
        <span className={styles.title_txt}>Category (2021-2025)</span>
        <span className={styles.title_desc}>
          Sales performance by year - darker colors indicate higher sales
        </span>
      </div>
      <div style={{ marginTop: "16px", marginBottom: "16px" }}>
        <ViewModeSwitcher
          mode={viewMode}
          onChangeMode={setViewMode}
          disabled={false}
          showSwitch={true}
        />
      </div>
      {viewMode === "right" && (
        <div className={styles.pills_wrapper}>
          {yearlyTabs?.map((view: any) => (
            <div
              key={view?.viewId}
              onClick={() => handleCategorySelection(view?.label)}
              className={`${styles.view_btn} ${
                selectedCategory === view.label ? styles.selected_view : ""
              }`}
            >
              <span className={styles.label}>{view?.label}</span>
            </div>
          ))}
        </div>
      )}
      {viewMode === "left" ? (
        isEmpty(yearlyApiResponse) ? (
          <div className={tableStyles.no_data}>{t("noDataAvailable")}</div>
        ) : (
          <StackedGroupedBarChart
            data={yearlyApiResponse}
            showPills={true}
            theme={currentTheme}
            THEME_STYLE={THEME_STYLE}
            CATEGORY_COLORS={CATEGORY_COLORS}
            ALL_PILL_COLOR={ALL_PILL_COLOR}
            isShowAllPill={false}
          />
        )
      ) : isEmpty(filteredTableData) ? (
        <div className={tableStyles.no_data}>{t("noDataAvailable")}</div>
      ) : (
        <GenericTable
          tableData={filteredTableData}
          kpiCode="category-mix"
          highlightColumns={[1, 3]}
        />
      )}
    </div>
  );
};

export default YearlyView;
